import * as React from 'react';
import {connect} from 'react-redux';
import {RootState} from '../../../../store';
import * as ProjectsStore from '../../../../store/projects';
import * as RuntimeStore from '../../../../store/runtime';
import * as CommonValuesStore from '../../../../store/common-values';
import {bindActionCreators} from 'redux';
import {UserState} from 'redux-oidc';
import {ConnectedRouterProps} from 'connected-react-router';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {Button} from '@mui/material';
import {Project} from '../../../../store/projects';
import {Company, Person} from '../../../../store/common-values/commonTypes';
import {apiRequest} from '../../../../utils/api';
import ReportUploadForm from './ReportUploadForm';
import GoBackContainer from './../../../application/GoBackContainer';
import {match} from 'react-router';
import {Info} from "@mui/icons-material";

// At runtime, Redux will merge together...
type ReportUploadFormProps =
    & typeof RuntimeStore.actionCreators
    & RuntimeStore.RuntimeState
    & ProjectsStore.ProjectsState
    & typeof ProjectsStore.actionCreators
    & CommonValuesStore.CommmonValuesState
    & typeof CommonValuesStore.actionCreators
    & ConnectedRouterProps
    & UserState
    & { match: match<{ pid: string, aid?: string }> };

class ReportUploadFormContainer extends React.PureComponent<ReportUploadFormProps> {
    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.ensureDataFetched();
    }

    componentDidUpdate(prevProps: ReportUploadFormProps) {
        //Check if item was saved
        if (this.props.reportUploaded && prevProps.reportUploaded != this.props.reportUploaded) {
            debugger;
            this.props.history.push(`/projects/details/${this.props.project?.id}/assessment/${this.props.certificationId}`);
            // this.goBack();
            // this.props.showNotification("report was uploaded successfully", "info");
        }
    }

    private uploadReport(reportFile: File, levelId: number, comments?: string): void {
        this.props.uploadReport(this.props.match.params.pid, levelId, reportFile, comments, this.props.match.params.aid);
    }

    private cancel(): void {
        this.goBack();
    }

    private goBack(): void {
        if (this.props.history.length > 0)
            this.props.history.goBack();
        else
            this.props.history.replace("/incidents");
    }

    public render() {
        return (
            <React.Fragment>
                <GoBackContainer title="Prosjektregistrering" onGoBack={() => this.props.history.goBack()}>
                    <ReportUploadForm
                        levels={this.props.levels}
                        isLoading={this.props.isLoading}
                        onSave={(f, l, c) => this.uploadReport(f, l, c)}
                        onCancel={() => this.cancel()}
                        newCertification={!this.props.match.params.aid}
                    />
                    <div className="row mb-3">
                        <div className="col-sm-12 info">
                            <span><Info /><b>Vennligst ikke lukk nettsiden før rapporten er lastet opp.</b>&nbsp;Opplasting av rapporten kan ta flere minutter. Du kan laste opp bevis etter at rapporten er lastet opp</span>
                        </div>
                    </div>
                    {!this.props.isLoading && this.props.reportUploadError && (
                        <div className="row mb-3">
                            <div className="col-sm-12 error">
                                <span>{this.props.reportUploadError}</span>
                            </div>
                        </div>
                    )}
                </GoBackContainer>
            </React.Fragment>
        );
    }

    private ensureDataFetched() {
        this.props.resetFormState();
        this.props.ensureLevels();
    }
}

export default connect(
    (state: RootState) => {
        const {commonValues, oidc, projects, runtime} = state;
        return {
            ...projects,
            ...commonValues,
            ...runtime,
            ...oidc
        };
    },
    (dispatch) => {
        return {
            ...bindActionCreators(
                Object.assign(
                    {},
                    ProjectsStore.actionCreators,
                    RuntimeStore.actionCreators,
                    CommonValuesStore.actionCreators
                ), dispatch)
        };
    }
)(ReportUploadFormContainer as any); // eslint-disable-line @typescript-eslint/no-explicit-any
